export type Size = {
  width: number;
  height: number;
}

export interface Point {
  x: number;
  y: number;
}

export type IRectangle = Size & Point

export function roundPoint(point: Point): Point {
  return { x: Math.round(point.x), y: Math.round(point.y) };
}

export class Rectangle {

  constructor(public x: number, public y: number, public width: number, public height: number) {
  }

  containsPoint(x: number, y: number): boolean {
    return x >= this.x && y >= this.y && x < this.x + this.width && y < this.y + this.height;
  }
}

export function arePointsEqual(array1?: Point[], array2?: Point[]): boolean {
  return (array1 == undefined && array2 == undefined) ||
    (
      array1 !== undefined && array2 !== undefined &&
      array1.length == array2.length &&
      array1.every((a, i) => a.x === array2[i].x && a.y === array2[i].y)
    );
}

export function areRectanglesEqual(rect1?: Rectangle, rect2?: Rectangle): boolean {
  return (rect1 === undefined && rect2 === undefined) ||
    (
      rect1 !== undefined && rect2 !== undefined &&
      rect1.x === rect2.x && rect1.y === rect2.y &&
      rect1.width === rect2.width && rect1.height === rect2.height
    );
}
